import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { observer } from 'mobx-react-lite';
import { Platform } from 'react-native';

import { IS_WEB } from '@utils';
import { Header, WebHeader } from '@components';
import {
  SuccessfulSignInScreen,
  QuestionnaireScreen,
  // UsersSuggestionScreen,
  FollowersScreen,
  FollowingScreen,
  InviteSuggestionScreen,
  SkillLevelQuestionnaireScreen,
} from '@screens';
import { screens } from './screens';
// import { UserProfileTabNavigator } from './UserProfileTabNavigator';
import type { PersonalizationStackParamListType } from './types';

const PersonalizationStack =
  createNativeStackNavigator<PersonalizationStackParamListType>();

export const PersonalizationNavigator = observer(() => {
  return (
    <PersonalizationStack.Navigator
      initialRouteName={screens.SuccessfulSignIn}
      screenOptions={{
        headerShown: IS_WEB,
        header: () => <WebHeader isShowTabButtons={false} />,
      }}
    >
      <PersonalizationStack.Screen
        component={SuccessfulSignInScreen}
        name={screens.SuccessfulSignIn}
      />
      <PersonalizationStack.Screen
        component={SkillLevelQuestionnaireScreen}
        name={screens.SkillLevelQuestionnaire}
      />
      <PersonalizationStack.Screen
        component={QuestionnaireScreen}
        name={screens.Questionnaire}
      />
      {/* Hiding the "Users Suggestion" screen for now according
      to requirements in Jira ticket SYN-1387
    */
      /* <PersonalizationStack.Screen
        component={UsersSuggestionScreen}
        name={screens.UsersSuggestion}
        options={{ headerShown: false }}
      /> */}
      {/* <PersonalizationStack.Screen
        component={UserProfileTabNavigator}
        name={screens.UserProfileTabNavigator}
        options={{
          headerShown: true,
          header: (props) =>
            Platform.select({
              web: <WebHeader isShowTabButtons={false} />,
              default: <Header {...props} />,
            }),
        }}
      /> */}
      <PersonalizationStack.Screen
        component={FollowersScreen}
        name={screens.Followers}
        options={{
          headerShown: true,
          header: (props) =>
            Platform.select({
              web: <WebHeader isShowTabButtons={false} />,
              default: <Header {...props} />,
            }),
        }}
      />
      <PersonalizationStack.Screen
        component={FollowingScreen}
        name={screens.Following}
        options={{
          headerShown: true,
          header: (props) =>
            Platform.select({
              web: <WebHeader isShowTabButtons={false} />,
              default: <Header {...props} />,
            }),
        }}
      />
      <PersonalizationStack.Screen
        component={InviteSuggestionScreen}
        name={screens.InviteSuggestion}
      />
    </PersonalizationStack.Navigator>
  );
});
